import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import Recaptcha from 'react-recaptcha';


import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioContrasena from '../servicios/ServicioContrasena';

export default class RecuperaContrasena extends Component {

  constructor() {
    super();
    this.state = {
      usuario: {},
      errores: {},
      mostrarModalRecuperaContrasena: false,
      verificaCapchap: false
    }
  }
  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  recuperarContrasena = () => {
    const { usuario,verificaCapchap } = this.state;

    const resultadoValidacion = this.validarFormulario(usuario);
    this.setState({ errores: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      if (verificaCapchap == true) {
        servicioContrasena.cambioContrasena(usuario).then(response => {
          if (response.data.error) {
            this.growl.show({ severity: 'error', summary: 'Error Message', detail: response.data.mensaje });
          } else {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.setState({ usuario: {}, errores: {}, mostrarModalRecuperaContrasena: false });
          }
        })
      } else {
        this.growl.show({ severity: 'error', summary: 'Error', detail: 'Falta el captchap' });
      }
    }


  }

  validarFormulario = (usuario) => {
    const errores = {};
    if (!usuario.usuario)
      errores.usuario = "El rfc es requerido";
    return errores;
  }

  recaptchaLoad = () => {

  }
  verificaCapchaCorrecto = (response) => {
    if (response) {
      this.setState({
        verificaCapchap: true
      });
    }
  }


  render() {

    let { errores, usuario } = this.state;


    const footer = (
      <div>
        <Button onClick={this.recuperarContrasena} label="Recuperar" />
        <Button onClick={(e) => this.setState({ mostrarModalRecuperaContrasena: false, usuario: {} })} label="Cancelar" className="p-button-danger" />
      </div>
    );

    return (
      <div>
        <Growl ref={(el) => this.growl = el} />
        <Button label="Recupera contraseña" icon="pi-md-help" className="indigo-btn" onClick={(e) => this.setState({ mostrarModalRecuperaContrasena: true })} />

        <div className="p-grid">
          <Dialog header="Se te olvidó tu contraseña" style={{ width: '60%' }} modal={true} visible={this.state.mostrarModalRecuperaContrasena} onHide={this.ocultarModal} footer={footer} onHide={(e) => this.setState({ mostrarModalRecuperaContrasena: false })}>
            <div className="p-grid">
              <div className="p-col-12">
                <label htmlFor="contrasenia">*Para poder recueperar tu contraseña es nesesario tener a la mano tu RFC de persona Física</label>
              </div>

              <div className="p-col-12 p-md-2">
                <label htmlFor="contrasenia">*Ingresa RFC</label>
              </div>
              <div className="p-col-12 p-md-4">
                <InputText id="usuario.usuario" name="usuario.usuario" value={usuario.usuario || ''} onChange={this.asignarValoresObjeto} className={errores.usuario ? 'p-error' : ''} />
                {errores.usuario ? <div><br /> <Message severity="error" text={errores.usuario} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-6">
                <Recaptcha sitekey="6LePa7UUAAAAABwcnOacAhKLhiTzPWZ8MT-ya6Ok" render="explicit" onloadCallback={this.recaptchaLoad} verifyCallback={this.verificaCapchaCorrecto} />
              </div>
            </div>
          </Dialog>

        </div>
      </div>

    );
  }
}